import React from "react";
import { Link } from "gatsby";
import notFoundImg from "../../images/not-found.svg";
import "./scss/index.scss";

export const NotFound: React.FC<{}> = () => {
  return (
    <div className="not-found card">
      <img className="not-found__img" src={notFoundImg} alt="not-found" />
      <div className="not-found__info">Nie możemy wyszukać strony.</div>
      <Link to="/">
        <button className="button not-found__button">
          wróć na stronę główną
        </button>
      </Link>
    </div>
  );
};
